<template>
  <div>
    <el-card class="content-card">
            <iframe :src="iframeSrc" frameborder="0" width="100%" height="1750px"></iframe>
    </el-card>
  </div>
</template>

<script>
export default {
    name: "BusinessRankingBI",
    computed: {
        iframeSrc() {
            return `https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=e17d1d69-c3cf-4c4c-9b0a-5f37118b75fd&accessTicket=1f4c707b-84b4-4289-8fd0-5b13a7a25999&dd_orientation=auto` 
        }
    }
};
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}


::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  //background-color: rgb(188, 188, 188);
  background-color:#E4E7F2;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>

